import React, { useEffect, useState } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { showToast } from "../../components/common/ToastNotification/ToastNotification";
import Swal from "sweetalert2";
import { Pagination, Stack } from "@mui/material";
import { getGalleryList, deleteSpecificGallery } from "../../api/service/gallery.service";
import "./Gallery.css";
import Button from "../../components/common/Button/Button";
import { useNavigate } from "react-router-dom";

const GalleryList = ({ setLoading }) => {
const navigate = useNavigate();
  const [gallery, setGallery] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);



  const fetchGallery = async (pageNumber = 1) => {
    try {
      setLoading(true);
      const res = await getGalleryList(pageNumber, 10);

      setGallery(res.data.data);
      setTotalPages(res.data.last_page);
    } catch (error) {
      console.log("Failed to fetch gallery:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGallery(page);
  }, [page]);



  const handleEdit = (item) => {
    navigate(`/update-gallery/${item.id}`);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This image will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);

          let res = await deleteSpecificGallery(id);


          fetchGallery(page);

          showToast.success(res?.message || "Gallery deleted successfully!");

        } catch (error) {
          showToast.error(error?.message || "Failed to delete gallery");
        } finally {
          setLoading(false);
        }
      }
    });
  };




  return (
    <div className="container-fluid">

      <div className="d-flex justify-content-between  mb-3">
        <div className="d-flex gap-2 align-items-center">
          <FaArrowLeftLong
            style={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
          <h3 className="management-tile mb-0 ml-2">
            Gallery Management
          </h3>
        </div>
        <Button onClick={() => navigate("/add-gallery")}>Add New Gallery</Button>
      </div>




      <div className="row g-3">
        {gallery.length > 0 ? (
          gallery.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6 col-sm-12">
              <div className="image-preview-box mt-2">

                <div className="image-actions">
                  <span className="icon-btn" onClick={() => handleEdit(item)}>
                    <FaRegEdit size={15} />
                  </span>
                  <span
                    className="icon-btn delete"
                    onClick={() => handleDelete(item.id)}
                  >
                    <MdDelete size={16} />
                  </span>
                </div>

                <img
                  src={item.image?.url}
                  alt={item.title}
                  className="img-fluid"
                />

                <div className="image-title">{item.title}</div>
                <div className="image-category">{item.category}</div>

              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <div className="text-center py-5 text-muted">
              <h5 className="mb-2">Gallery data not available</h5>
              <p className="mb-0">No images found to display</p>
            </div>
          </div>
        )}
      </div>



      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
            />
          </Stack>
        </div>
      )}
    </div>
  );
};

export default GalleryList;
